import { createContext, useContext, ReactNode } from "react";
import { useAuth, Profile } from "@/hooks/useAuth";
import { User, Session } from "@supabase/supabase-js";

interface AuthContextValue {
  user: User | null;
  session: Session | null;
  profile: Profile | null;
  /** The signed-in user's profile read has answered (a row or none; never a failed read). */
  profileSettled: boolean;
  loading: boolean;
  isPremium: boolean;
  signUp: (email: string, password: string, metadata?: { marketing_opt_in?: boolean }, redirectPath?: string) => Promise<{ error: Error | null; accessToken?: string; alreadyRegistered?: boolean }>;
  signIn: (email: string, password: string) => Promise<{ error: Error | null }>;
  signInWithGoogle: (redirectPath?: string) => Promise<{ error: Error | null }>;
  signOut: () => Promise<void>;
  refreshProfile: () => Promise<void>;
  checkSubscription: () => Promise<void>;
}

const AuthContext = createContext<AuthContextValue | undefined>(undefined);

export function AuthProvider({ children }: { children: ReactNode }) {
  const auth = useAuth();

  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
}

export function useAuthContext() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuthContext must be used within an AuthProvider");
  }
  return context;
}
